export const ENABLE_PRESCREENING = true;

export const BOT_USE_CASES = {
  DATA_ENRICHMENT: 'data_enrichment',
  PRESCREENING: 'prescreening',
  SOURCING: 'sourcing',
  APPLICATION_INBOUND_WEB: 'application_inbound_web',
} as const;

export const getDiscoverAttributeWarningMessage = (
  t: (arg1: string, arg2: string) => string,
): string =>
  `${t(
    'Warning_job_match_variable_requires_a_prior_job_match_node_or_link_to_a_flow_containing_the_node_Missing_this_may_cause_errors',
    'Warning: job match variable requires a prior job match node or link to a flow containing the node. Missing this may cause errors',
  )}.`;
